import { Form, Icon, Input } from 'antd';
import _ from 'lodash';
import InputMask from 'react-input-mask';
import styles from './index.module.less';

const FormItem = Form.Item;

const LoginFormItem = (props) => {
  const {
    name,
    rules,
    icon,
    placeholder,
    type,
    getFieldDecorator,
    label,
    errors,
    disabled,
    autoFocus,
    initialValue,
    decoratorOptions = {},
    validateFirst,
    validateTrigger,
  } = props;

  let submitErrors = [];
  if (errors) {
    submitErrors = _.groupBy(errors, 'id');
  }

  let FormInput = (
    <Input
      size="large"
      placeholder={placeholder}
      type={type}
      disabled={disabled}
      prefix={icon && <Icon type={icon} className={styles.prefixIcon} />}
      autoFocus={autoFocus}
    />
  );

  if (type === 'password') {
    FormInput = (
      <Input.Password
        size="large"
        placeholder={placeholder}
        disabled={disabled}
        prefix={icon && <Icon type={icon} className={styles.prefixIcon} />}
        autoFocus={autoFocus}
      />
    );
  } else if (type === 'phone_number') {
    FormInput = (
      <InputMask
        className="ant-input ant-input-lg"
        mask="(999) 999-9999"
        placeholder="123-456-7890"
      />
    );
  }

  const options = { rules, ...decoratorOptions };
  if (initialValue) {
    options.initialValue = initialValue;
  }
  if (validateFirst !== undefined) {
    options.validateFirst = validateFirst;
  }
  if (validateTrigger !== undefined) {
    options.validateTrigger = validateTrigger;
  }

  const fieldErrors = submitErrors[name];
  const errorToDisplay = fieldErrors ? fieldErrors[0] : null;
  const errorMessage = errorToDisplay ? errorToDisplay.detail : '';

  return (
    <FormItem className={styles.loginFormItem} label={label || placeholder}>
      {getFieldDecorator(name, options)(FormInput)}
      <div className={styles.error}>{errorMessage}</div>
    </FormItem>
  );
};

export default LoginFormItem;
